/* template */
<template><div :class="({ 'is-mp': bottomMargin })" class="money-saving-tips"><mpx-view @tap="moneySavingClick" class="left"><template v-if="(moneySaving)"><span class="label">{{ $t('home.youHaveSaved') }}</span><div class="value"><span class="rmb-symbol">¥</span><span class="value-number">{{ (moneySaving / 100).toFixed(2) }}</span></div><div class="arrow-right"><arrow-right class="arrow"/></div></template><div class="no-saving-tips label" v-else>{{ $t('home.recommendPromoDeal') }}</div></mpx-view><mpx-view @tap="triggerGoto" class="right"><span class="no-coupons label">{{ $t('personal.purchaseHistory') }}</span><div class="arrow-right"><arrow-right class="arrow"/></div></mpx-view><mpx-image :src="(bubbleImage)" class="bubble" v-if="(bubbleImage && bubbleShow)"></mpx-image></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m34d96f6a"}'>
@import '../../lib/stylus/variable.styl'

.money-saving-tips
  position relative
  width 584rpx
  height 99rpx
  margin 8rpx auto 0 auto
  padding 0 51rpx
  background-image linear-gradient(180deg, rgba(206, 46, 0, 0.58) 0%, rgba(205, 46, 0, 0.51) 100%)
  border-radius 20rpx
  border 2rpx solid rgba(255, 233, 183, 0.3)
  display flex
  flex-flow row nowrap
  justify-content flex-start
  align-items center
  &.is-mp
    margin 30rpx
.bubble
  position absolute
  top -4rpx
  right -4rpx
  height 30rpx
  width 102rpx
.left, .right
  display flex
  flex-flow row nowrap
  justify-content flex-start
  align-items center
.left
  flex auto
.right
  flex none
  width 180rpx
  justify-content flex-end
.label
  color #fff
  font-size 28rpx
  font-weight $fw-medium
  line-height 1
.value
  margin-left 7rpx
  margin-right 7rpx
  .rmb-symbol, .value-number
    font-family BarlowSemiCondensed-Medium
    color #FFE895
    font-weight $fw-weight
    font-size 42rpx
    letter-spacing -0.79rpx
    line-height 1
  .rmb-symbol
    font-size 22rpx
    margin-right 4rpx
.arrow-right
  margin-left 8rpx
  height 32rpx
  line-height 1
  .arrow
    width 9rpx
    height 16rpx

body.en-us
  .money-saving-tips
    .label
      font-size 24rpx
      letter-spacing -1rpx
    .value
      .rmb-symbol
        margin-right 0
    .right
      .value
        margin-left 2rpx
        margin-right 2rpx
      .arrow-right
        margin-left 4rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { is } from '@didi/webx-js'

createComponent({
  name: 'MoneySavingUI',
  properties: {
    moneySaving: Number,
    availabelCoupons: Number,
    activitiesProgressLength: Number,
    bubbleImage: String,
  },
  data: {
    // isMiniProgram: is('miniprogram'),
    bubbleShow: true,
  },
  computed: {
    bottomMargin() {
      return is('miniprogram') && !this.activitiesProgressLength
    },
  },
  methods: {
    moneySavingClick() {
      this.triggerEvent('money-saving-click-transmit')
    },
    triggerGoto() {
      this.bubbleShow = false
      this.triggerEvent('goto-history')
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "money-saving-ui34d96f6a",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'arrow-right':getComponent(require("./arrow-right.mpx?component=true&componentId=arrow-right75d32029")),'mpx-view':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
